import React from "react";
import ButtonEdit from "./../../../components/Button/ButtonEdit";
import ButtonDelete from "./../../../components/Button/ButtonDelete";
import Button from "./../../../components/Button/Button";

const PageList = ({ pages, onEdit, onDelete, onManageArticles }) => {
  return (
    <div className="w-full overflow-x-auto mt-4">
      <table className="w-full text-sm text-left border border-gray-300 dark:border-gray-600">
        <thead className="bg-gray-300 dark:bg-gray-800">
          <tr>
            <th className="p-2">Titre</th>
            <th className="p-2">Slug</th>
            <th className="p-2">Actif</th>
            <th className="p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {pages.map((page) => (
            <tr
              key={page.id}
              className="border-t border-gray-300 dark:border-gray-600"
            >
              <td className="p-2">{page.titre}</td>
              <td className="p-2">{page.slug}</td>
              <td className="p-2">{page.actif ? "Oui" : "Non"}</td>
              <td className="p-2 flex gap-1">
                <ButtonEdit onClick={() => onEdit(page)} />
                <ButtonDelete onClick={() => onDelete(page.id)} />
                <Button
                  text="Gérer articles"
                  onClick={() => onManageArticles(page)}
                  className="ml-4 mb-2"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PageList;
